/* global axios */
import ApiClient from './ApiClient';

class InstagramConnections extends ApiClient {
  constructor() {
    super('instagram_connections', { accountScoped: true });
  }

  // Valores que a tela de conexão manda o cliente colar no painel da Meta
  // (endereço do webhook e código de verificação). Vivem no servidor: o
  // código de verificação é da instância e não existe no bundle do
  // navegador.
  setup() {
    return axios.get(`${this.url}/setup`);
  }

  // O id da URL é o da INBOX (o mesmo que a listagem devolve), não o do
  // canal — é assim que a rota do backend está declarada (param: :inbox_id).
  reconnect(inboxId, data) {
    return axios.post(`${this.url}/${inboxId}/reconnect`, data);
  }
}

export default new InstagramConnections();
